module.exports = __webpack_public_path__ + "static/media/ehealth_website_banner_mobile.5c716066.jpg";